import { API } from "@/api"
import { useAddAlert } from "./useAddAlert";
import { useState } from "react";

function ensureXlsxExtension(filename: string) {
    if (!filename.toLowerCase().endsWith('.xlsx')) {
       return filename + '.xlsx';
    }
    return filename;
}

interface DownloadFunctionParams {
  api: string;
  name: string;
  params?: object;
  alertText?: string
}

export const useDownloadFile = () => {
    const addAlert = useAddAlert();
    const [loading, setLoading] = useState(false);

    const download = ({ api, name, params = {}, alertText = 'Шаблон загружен!'}: DownloadFunctionParams): void => {
        if (loading) return
        setLoading(true)

        API.get(api, {
            responseType: 'arraybuffer', // Указываем, что ожидаем бинарные данные
            params: params,
        })
        .then((res) => {
            if (res?.data) {
            // Создаем временную ссылку для скачивания файла
            const url = URL.createObjectURL(
                new Blob([res.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                }),
            )
            const link = document.createElement('a')
            link.href = url
            link.download = ensureXlsxExtension(name) // Имя файла
            document.body.appendChild(link) // Добавляем ссылку в DOM
            link.click() // Программно "кликаем" по ссылке
            document.body.removeChild(link) // Удаляем ссылку из DOM после скачивания
            URL.revokeObjectURL(url) // Освобождаем память, удаляя временный URL
            addAlert({ text: alertText })
            } 
            else {
                addAlert({
                    title: 'Ошибка',
                    text: 'Ошибка при скачивании: данные отсутствуют',
                    type: 'error',
                })
            }
        })
        .catch((error) => {
            console.error('Ошибка при скачивании файла:', error) // Логируем ошибку
            addAlert({ text: 'Ошибка при скачивании!', type: 'error' })
        })
        .finally(() => {
            setLoading(false)
        })
    }
    return { download, loading };
}
